import { Link } from 'react-router-dom'
import { Box, Button, Toolbar, Typography, IconButton } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import LanguageDropdown from './change lang'

const CToolBar = ({
  currentPath,
  t,
  isMobile,
  mobileMenuOpen,
  setMobileMenuOpen,
}) => {
  return (
    <Toolbar
      variant="h6"
      component="div"
      sx={{
        zIndex: 99,
        flexGrow: 1,
        cursor: 'pointer',
        fontWeight: 700,
        // width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        WebkitBackgroundClip: 'text',
        letterSpacing: '1px',
      }}
    >
      <Link to="/" style={{ textDecoration: 'none' }}>
        <Typography
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            cursor: 'pointer',
            fontWeight: 700,

            zIndex: 2,
            // background: 'linear-gradient(45deg, #00bcd4 30%, #80deea 90%)',
            WebkitBackgroundClip: 'text',
          }}
        >
          <img
            src="/logo-Photoroom.png"
            alt="Logo"
            style={{ width: '130px', height: '130px' }}
          />
        </Typography>
      </Link>
      <LanguageDropdown />
      {isMobile && !mobileMenuOpen && (
        <IconButton
          onClick={() => setMobileMenuOpen(true)}
          sx={{
            position: 'relative', // Ensures it's above other elements
            // bottom: 20,
            // margin: '10px 10px',
            color: 'secondary.main',
            backgroundColor: 'primary.main',
            zIndex: 999, // Keeps it clickable
            width: '50px',
            height: '50px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <MenuIcon />
        </IconButton>
      )}
      {/* Mobile Navigation Drawer */}

      {!isMobile && (
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button
            color="inherit"
            component={Link}
            to="/"
            sx={{
              fontFamily: 'Montserrat',
              textDecoration: 'none',
              color: 'text.secondary',
              fontSize: '16px',
              fontWeight: currentPath === '/' ? 900 : 600,
              '&:hover': {
                fontWeight: 900,
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '0',
                left: '0',
                width: currentPath === '/' ? '100%' : '0',
                height: '4px',
                backgroundColor: '#327d81',
                transition: 'width 0.3s ease-in-out',
              },
            }}
          >
            {t('Titles.Home')}
          </Button>
          <Button
            color="inherit"
            component={Link}
            to="/services"
            sx={{
              fontFamily: 'Montserrat',
              textDecoration: 'none',
              fontSize: '16px',
              color: 'text.secondary',
              fontWeight: currentPath === '/services' ? 900 : 600,
              '&:hover': {
                fontWeight: 900,
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '0',
                left: '0',
                width: currentPath === '/services' ? '100%' : '0',
                height: '4px',
                backgroundColor: '#327d81',
                transition: 'width 0.3s ease-in-out',
              },
            }}
          >
            {t('Titles.services1')}
          </Button>
          <Button
            color="inherit"
            component={Link}
            to="/about"
            sx={{
              fontFamily: 'Montserrat',
              textDecoration: 'none',
              fontSize: '16px',
              color: 'text.secondary',
              fontWeight: currentPath === '/about' ? 900 : 600,
              '&:hover': {
                fontWeight: 900,
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '0',
                left: '0',
                width: currentPath === '/about' ? '100%' : '0',
                height: '4px',
                backgroundColor: '#327d81',
                transition: 'width 0.3s ease-in-out',
              },
            }}
          >
            {t('Titles.about')}
          </Button>
          <Button
            color="inherit"
            component={Link}
            to="/contact"
            sx={{
              fontFamily: 'Montserrat',
              textDecoration: 'none',
              fontSize: '16px',
              color: 'text.secondary',
              fontWeight: currentPath === '/contact' ? 900 : 600,
              transition: 'all 0.3s ease',
              '&:hover': {
                // borderBottom: '4px solid #327d81', // Keep the border on hover
                fontWeight: 900,
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '0',
                left: '0',
                width: currentPath === '/contact' ? '100%' : '0',
                height: '4px',
                backgroundColor: '#327d81',
                transition: 'width 0.3s ease-in-out',
              },
            }}
          >
            {t('Titles.contact')}
          </Button>
        </Box>
      )}
    </Toolbar>
  )
}
export default CToolBar
